import script from "./PersonalInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&setup=true&lang=js"

import "./PersonalInfo.vue?vue&type=style&index=0&id=5117d4c0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5117d4c0"]])

export default __exports__